<template lang="pug">
  component(ref="taskViewComponent" :is="view" v-if="variables" :task="task" :vars="variables" :loading="loading || submitMode")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import minioAPI from '@/services/minio'
import dictionariesAPI from '@/services/dictionaries'
import validationFocus from '@/utils/validationFocus'

export default {
  name: 'TaskController',

  props: ['taskId'],

  provide() {
    const that = this
    return {
      ctrl: {
        submit(variables) {
          that.submit(variables || [])
        },
        update(variables) {
          that.update(variables || [])
        },
        save(variables) {
          that.save(variables)
        },
        isDirty(form) {
          return form.inputs.some(input => (input.menuProps || input.radios ? input.hasInput : input.hasFocused && input.initialValue !== input.value))
        },
        get(name, alt) {
          return that.variables[name] ? that.variables[name].value : alt
        },
        getDownloadUrls(files) {
          if (files) {
            return minioAPI.presignedGetObjectUrls(files)
          }
          return null
        },
        getDictionary(dictionary, payload) {
          return dictionariesAPI.request(dictionary, payload)
        },
        getСancelableDictionary(dictionary, payload) {
          return dictionariesAPI.cancelableRequest(dictionary, payload)
        },
        getCurrentUser() {
          return Object.assign(that.profile, { groups: that.groups, locale: that.locale })
        },
        getCurrentTask() {
          return that.task
        },
        confirm(payload) {
          return that.showConfirm({ title: payload.title,
            text: payload.text,
            persistent: payload.persistent,
            resolveText: payload.resolveText ? payload.resolveText : that.$tf('task.yes'),
            rejectText: payload.rejectText ? payload.rejectText : that.$tf('task.no') })
        },
        alert(title) {
          that.setSnackbar(title)
        },
        focusOnInvalid(form) {
          validationFocus.focusOnFirstInvalidOf(form)
        },
        t(key) {
          return that.$tf(`${that.task.processDefinitionId.split(':')[0]}.${key}`)
        },
        routerPush(arg) {
          return that.$router.push(arg)
        },
      },
    }
  },

  computed: {
    ...mapGetters({
      view: 'task/view',
      task: 'task/task',
      variables: 'task/variables',
      submitMode: 'task/submitMode',
      loading: 'tools/loading',
      profile: 'auth/profile',
      groups: 'auth/groups',
      locale: 'tools/locale',
    }),
  },

  methods: {
    ...mapActions({
      getTask: 'task/getTask',
      submit: 'task/submit',
      update: 'task/updateVariables',
      save: 'task/save',
      showConfirm: 'tools/showConfirm',
      setSnackbar: 'tools/setSnackbar',
    }),
  },

  beforeRouteUpdate(to, from, next) {
    this.getTask(to.params.taskId)
      .then(() => {
        next()
      })
      .catch(() => {
        next('Drawer')
      })
  },

  beforeRouteLeave(to, from, next) {
    if (!this.submitMode && this.$refs.taskViewComponent && this.$refs.taskViewComponent.$dirty && this.$refs.taskViewComponent.$dirty()) {
      this.showConfirm({
        title: this.$tf('task.saveChanges'),
        persistent: true,
        resolveText: this.$tf('task.save'),
        rejectText: this.$tf('task.no') })
        .then(() => {
          this.$refs.taskViewComponent.$save()
          next()
        }).catch(() => {
          next()
        })
    } else {
      next()
    }
  },
}
</script>

<style lang="stylus"></style>



// WEBPACK FOOTER //
// src/components/task/TaskController.vue